module.exports = __webpack_public_path__ + "static/img/camo_chair.e2769cee.png";